import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HistoryDetailService } from 'src/app/services/history-detail.service';
import { __setFunctionName } from 'tslib';

@Component({
    selector: 'app-search-img-cell-renderer',
    templateUrl: './search-img-cell-renderer.component.html',
    styleUrls: ['./search-img-cell-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class SearchImgCellRendererComponent {
  @Input() name: string;
  public params: any;
  eventId: any;
  constructor(
    public router: Router,
    public readonly history: HistoryDetailService
    ) {

  }
  

  agInit(params: any): void {
    this.params = params;
  }

  routeToEvent() {
    this.eventId = this.params.data.event_id;
    localStorage.setItem('eventId', this.eventId);
    this.router?.navigate(['/history/event']);
  }



}